import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrentVoyagesComponent } from './current-voyages.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { MapViewModule } from './pages/map-view/map-view.module';
import { CustomInputModule } from "../../shared/components/custom-input/custom-input.module";
import { MatSortModule } from '@angular/material/sort';
import { ExpansionPanelModule } from "../../shared/components/expansion-panel/expansion-panel.module";

@NgModule({
    declarations: [CurrentVoyagesComponent,],
    exports: [CurrentVoyagesComponent],
    imports: [
    CommonModule,
    FormsModule,
    CustomDropdownModule,
    CustomDatePickerModule,
    ReactiveFormsModule,
    MaterialModule,
    MatPaginatorModule,
    MatSortModule,
    CustomTimpickerModule,
    MapViewModule,
    CustomInputModule,
    ExpansionPanelModule
]
})
export class CurrentVoyagesModule {}
